export default __webpack_public_path__ + "static/media/winner6.b98527d0.jpg";